import styled from "styled-components";
export const QuizMessagePopUp = styled.div`
position: absolute;
  background-color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding:10px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px #333333;
  z-index: 2; /* Ensures the popup is on top of other elements */
`;

// CloseButton
export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;